import { Types } from "../actionTypes";

export const initialState = {};

const storeLocation = (state = initialState, action) => {
  switch (action.type) {
    case Types.FETCH_STORE_LOCATION: {
      return {
        ...state,
        error: false,
      };
    }
    case Types.FETCH_STORE_LOCATION_SUCCESS: {
      const { response } = action;
      return {
        ...state,
        data: response,
      };
    }
    case Types.FETCH_STORE_LOCATION_FAILURE: {
      return {
        ...state,
        error: true,
      };
    }
    case Types.FETCH_OFFER_KEY: {
      return {
        ...state,
        error: false,
      };
    }

    case Types.FETCH_OFFER_KEY_SUCCESS: {
      const { response } = action;
      return {
        ...state,
        data: response,
      };
    }

    case Types.FETCH_OFFER_KEY_FAILURE: {
      return {
        ...state,
        error: true,
      };
    }
    case Types.RESET_STORE_LOCATION: {
      return {
        ...initialState,
      };
    }
    default:
      return state;
  }
};

export const getStoreLocation = (state) => state.data || null;
export const getStoreError = (state) => state.error || null;

export default storeLocation;
